import { Role } from '@bioliberty/core';

export function hasAdminAccess({ roles }: { roles: string[] }): boolean {
  return isAdmin({ roles }) || isSuperAdmin({ roles });
}

export function hasInternalAccess({ roles }: { roles: string[] }): boolean {
  return isBiolibertyAdmin({ roles });
}

export function isAdmin({ roles }: { roles: string[] }): boolean {
  return roles.includes(Role.Admin);
}

export function isSuperAdmin({ roles }: { roles: string[] }): boolean {
  return roles.includes(Role.SuperAdmin);
}

export function isBiolibertyAdmin({ roles }: { roles: string[] }): boolean {
  return roles.includes(Role.BiolibertyAdmin);
}
